import React from "react";

function SidebarLinkSkeleton({ isCollapsed }) {
  return (
    <div className="flex items-center w-full pl-[16px] gap-3 animate-pulse">
      <span className="w-10 h-10 rounded-full bg-gray-200 shrink-0" />
      <span
        className="h-3 rounded bg-gray-200 overflow-hidden"
        style={{
          width: isCollapsed ? 0 : 112,
          opacity: isCollapsed ? 0 : 1,
          transition: "width 250ms ease-in-out, opacity 200ms ease-in-out",
        }}
      />
    </div>
  );
}

export default SidebarLinkSkeleton;
